import f3tch from 'f3tch';

import profile from '../../api/profiles/json.profile.api';

export default (team) =>
  f3tch('/crm/teams/').profile(profile()).body(team).post();
